<div class="default-404">
  <div class="px-4 pt-4 flex flex-column">
    <div class="flex h-full w-full align-items-center justify-content-center flex-1">
      <div class="w-full gap-4 pb-4 flex flex-column md:flex-row align-items-center flex-wrap justify-content-center md:mt-8">
        <div class="text flex flex-column ">
          <div class="title-not-found">404</div>
          <div class="subtitle-not-found">
            <span i18n>Page not found</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
